import { Typography, useTheme } from '@mui/material';

import { ATSConnectHiringRequestCandidateFeedbackTestIds } from 'data-testids/ATS';
import { CloseButton } from 'sharedComponents/Buttons';
import { FeedbackListPaneHeaderProps } from '../../../types/feedbackListTypes';
import { PrimaryChip } from 'sharedComponents/Chip/PrimaryChip';
import { Title, TitleAndChip, TopHeader } from '../../../styles/styles';
import { CandidateFeedbackModalTypes } from '../../../enums';

export const FeedbackListPaneHeader: React.FC<FeedbackListPaneHeaderProps> = ({
  count,
  onClose,
  roleTitle,
  titleText,
  modalType,
}) => {
  const theme = useTheme();
  const shouldShowChip = count !== undefined;
  const chipText =
    modalType === CandidateFeedbackModalTypes.SCORECARD
      ? `${count} scorecards`
      : `${count} references`;

  return (
    <>
      <TopHeader>
        <TitleAndChip>
          <Title
            data-testid={ATSConnectHiringRequestCandidateFeedbackTestIds.MODAL_TITLE}
            variant="heading7"
          >
            {titleText}
          </Title>
          {shouldShowChip && (
            <PrimaryChip
              dataTestId={ATSConnectHiringRequestCandidateFeedbackTestIds.FEEDBACK_COUNT_CHIP}
              label={chipText}
              sx={{ marginLeft: theme.spacing(1) }}
            />
          )}
        </TitleAndChip>
        <CloseButton
          dataTestId={ATSConnectHiringRequestCandidateFeedbackTestIds.CLOSE_MODAL_LIST_BUTTON}
          onClick={onClose}
        />
      </TopHeader>
      <Typography data-testid={ATSConnectHiringRequestCandidateFeedbackTestIds.ROLE_TITLE}>
        {roleTitle}
      </Typography>
    </>
  );
};
